import { Route, Routes } from 'react-router-dom';

import { ROUTES } from './utils/constants';

import Communities from './pages/Communities/Communitis';
import Home from './pages/Home/Home';
import Product from './pages/Product/Product';
import Subscription from './pages/Subscription/Subscription';
import BeautyQuestions from './pages/BeautyQuestions/BeautyQuestions';
import NotAvailable from './pages/NotAvailable/NotAvailable';

import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className='App'>
      <Routes>
        <Route path={ROUTES.home} element={<Home />} />
        <Route path='*' element={<Home />} />
        <Route path={ROUTES.communities} element={<Communities />} />
        <Route path={ROUTES.product()} element={<Product />} />
        <Route path={ROUTES.subscription} element={<Subscription />} />
        <Route path={ROUTES.beautyQuestions} element={<BeautyQuestions />} />
        <Route path={ROUTES.notAvailable} element={<NotAvailable />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
